import React from 'react';

import type { ReactNode } from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
export type TextfieldLabelProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** html attribute to be passed down to input element */
  textFieldId?: string;
};

export function Label(props: TextfieldLabelProps) {
  const { children, className, textFieldId } = props;
  const classNames = cx(styles[toCamelCase('textField', 'label')], className);

  return (
    <label className={classNames} data-testid="textField-label" htmlFor={textFieldId || ''}>
      {children}
    </label>
  );
}

export default Label;
